import React from 'react';
import reactCSS from 'reactcss';
export var SliderSwatch = function SliderSwatch(_ref) {
  var hsl = _ref.hsl,
    offset = _ref.offset,
    _ref$onClick = _ref.onClick,
    onClick = _ref$onClick === undefined ? function () {} : _ref$onClick,
    active = _ref.active,
    first = _ref.first,
    last = _ref.last;
  var styles = reactCSS({
    'default': {
      swatch: {
        height: '12px',
        background: 'hsl(' + hsl.h + ', 50%, ' + offset * 100 + '%)',
        cursor: 'pointer'
      }
    },
    'first': {
      swatch: {
        borderRadius: '2px 0 0 2px'
      }
    },
    'last': {
      swatch: {
        borderRadius: '0 2px 2px 0'
      }
    },
    'active': {
      swatch: {
        transform: 'scaleY(1.8)',
        borderRadius: '3.6px/2px'
      }
    }
  }, {
    active: active,
    first: first,
    last: last
  });
  var handleClick = function handleClick(e) {
    return onClick({
      h: hsl.h,
      s: 0.5,
      l: offset,
      source: 'hsl'
    }, e);
  };
  return /*#__PURE__*/React.createElement('div', {
    style: styles.swatch,
    onClick: handleClick
  });
};
export default SliderSwatch;